import React from 'react';
import { Divider } from '@mui/material';

const ThinDivider = ({ ...rest }) => <Divider sx={{ m: 0, ...rest }} />;

export default ThinDivider;
